//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'keen-slider/keen-slider.min.css'
import KeenSlider from 'keen-slider'

//let onMainEventChange = null
export default {
  components: {},
  props: ['images'],
  data() {
    return {
      loading: true,
      hasPrev: false,
      hasNext: true,
      current: 0,
      slider: null,
      height: 0
    }
  },
  computed: {
    promotions() {
      let banners = _.get(this.$store.state, 'banners', [])

      if(this.user) {
        banners = _.reject(banners, {visibility: 'guest'})
      }      
      if(!this.user) {
        banners = _.reject(banners, {visibility: 'authenticated'})
      }

      banners = _.filter(banners, banner => { 
        let isValid = true;

        if(banner.starts_at && this.$date(banner.starts_at).isAfter()) {
          isValid = false
        }
        if(banner.ends_at && this.$date(banner.ends_at).isBefore()) {
            isValid = false
        } 
        return isValid
      })
      return banners
    },
    events() {
      return this.$store.state?.games?.mainEvents ?? []
    }
  },
  beforeDestroy: function () {
    emitter.off('*', this.onMainEventChange)
  },
  mounted() {
    this.currentEvents = []
    this.initInterval()

    emitter.on('*', this.onMainEventChange)

    let clientWidth = _.get(this.$refs, 'carousel.clientWidth', 500)
    this.height = (clientWidth / 2 + 20) * (16 / 9)

    this.$nextTick(() => {
      let clientWidth = _.get(this.$refs, 'carousel.clientWidth', 500)
      this.height = (clientWidth / 2 + 20) * (16 / 9)
    })
  },
  methods: {
    loadCarousel() {
      if (process.server) {
        return
      }
      this.slider = new KeenSlider(this.$refs.slider,
        {
          loop: true,
          slides: {
            perView: 1,
          },
          breakpoints: {
            '(min-width: 360px)': {
              slides: {
                perView: 1.04,
                spacing: 15,
                origin: 'center',
              },
            },
            '(min-width: 1000px)': {
              slides: {
                perView: 2.3,
                spacing: 15
              },
            },
          },
          initial: this.current,
          slideChanged: (s) => {
            this.current = s.track.details.rel
          },
      },
      [
          slider => {
            let timeout
            let mouseOver = false
            function clearNextTimeout() {
              clearTimeout(timeout)
            }
            function nextTimeout() {
              clearTimeout(timeout)
              if (mouseOver) return
              timeout = setTimeout(() => {
                slider.next()
              }, 1000*700)
            }
            slider.on("created", () => {
              slider.container.addEventListener("mouseover", () => {
                mouseOver = true
                clearNextTimeout()
              })
              slider.container.addEventListener("mouseout", () => {
                mouseOver = false
                nextTimeout()
              })
              nextTimeout()
              this.loading = false
            })
            slider.on("dragStarted", clearNextTimeout)
            slider.on("animationEnded", nextTimeout)
            slider.on("updated", nextTimeout)
          }
      ]);
    },
    onMainEventChange(type, e) {
      if (type === 'events') {
        if (e.filter(item => this.currentEvents.includes(item)).length) {
          this.fetchEvents()
        }
      }
    },
    async initInterval() {
      if (this.events.length > 0) {
        this.$nextTick(() => {
          this.loadCarousel()
        })
      }
      await this.fetchEvents()
    },
    isExternal(url){
      return ['https://', 'http://'].filter(u => url.toString().startsWith(u)).length > 0;
    },
    handleSlideClick(dataset) {
      if (dataset.action) {
        this.$root.$emit(dataset.action)
      } else if (dataset.url) {
        if (this.isExternal(dataset.url)) {
          window.open(dataset.url, _.get(dataset, 'openExternally', false) ? '_blank' : '_self');
        } else {
          this.$router.push(this.localePath({ path: dataset.url }))
        }
      }
    },
    async fetchEvents() {
      try {
        const response = await this.$infoapi().$get('/v1/superbanner/home', { params: {
            lang: this.lang,
            country: 'ES',
            bookmaker: this.$config.BOOKMAKER,
            mode: this.mode,
            sport: this.sport,
          } })
        await this.$store.commit('games/setMainEvents', response.items)
        this.currentEvents = _.map(response.items, 'id')
        this.$nextTick(() => {
          this.loadCarousel()
        })
      } catch (e) {
        console.log('error getting main events',e)
      }
    }
  }
}
